import React from 'react';

const Dashboard = () => {
  return (
    <div className="h-full bg-gray-100 p-1 overflow-hidden">
      {' '}
      {/* Added overflow-hidden */}
      {/* Header */}
      {/* Main Dashboard - Looker Embed */}
      <main className="bg-white rounded-lg shadow-lg h-[calc(100vh-90px)]">
        {' '}
        {/* h-[calc(100vh-8px)]Adjusted height calculation */}
        <div className="w-full h-full">
          {' '}
          {/* Removed fixed h-screen */}
          <iframe
            title="Looker Analytics Dashboard"
            src="https://lookerstudio.google.com/embed/reporting/e13ba236-12bf-4917-a939-83afeb7d7aee/page/PmhwE"
            frameBorder="0"
            style={{
              width: '100%',
              height: '100%',
              display: 'block', // Prevents inline spacing issues
              overflow: 'hidden', // Hides internal scrollbars if not needed
            }}
            allowFullScreen
            sandbox="allow-same-origin allow-scripts allow-popups allow-popups-to-escape-sandbox"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </main>
    </div>
  );
};

export default Dashboard;
